// document.addEventListener('DOMContentLoaded', function () {
//           let initialized = false;

//           function initSwatchDrawer() {
//             const swatchContainer = document.querySelector('[option-name="Upholstery"]');

//             if (!swatchContainer) return;

//             const swatchList = swatchContainer.querySelector('.swatch-view-custom-image');

//             if (!swatchList) return;

//             const items = swatchList.querySelectorAll(':scope > .swatch-view-item');

//             if (items.length <= 4) return;

//             let moreBtn = swatchList.parentElement.querySelector('.swatch-more-btn');

//             if (!moreBtn) {
//               moreBtn = document.createElement('button');
//               moreBtn.type = 'button';
//               moreBtn.className = 'swatch-more-btn';
//               moreBtn.innerHTML = '+ more &gt;';
//               swatchList.after(moreBtn);
//             }

//             /*
//              * CREATE OVERLAY
//              */

//             let overlay = document.querySelector('.swatch-drawer-overlay');

//             if (!overlay) {
//               overlay = document.createElement('div');
//               overlay.className = 'swatch-drawer-overlay';
//               document.body.appendChild(overlay);
//             }

//             /*
//              * CREATE DRAWER
//              */

//             let drawer = document.querySelector('.swatch-drawer');

//             if (!drawer) {
//               const vendorElement = document.querySelector('.vendor.product-detail__gap-sm');

//               const vendor = vendorElement ? vendorElement.innerText.trim() : '';

//               let fabricLink = '/pages/bauhaus-studio-upholstery';

//               if (vendor.includes('MCM House')) {
//                 fabricLink = '/pages/mcm-house-swatches';
//               } else if (vendor.includes('Bauhaus Studio')) {
//                 fabricLink = '/pages/bauhaus-studio-upholstery';
//               } else if (vendor.includes('Camerich')) {
//                 fabricLink = '/pages/camerich-upholstery';
//               }

//               drawer = document.createElement('div');
//               drawer.className = 'swatch-drawer';

//               drawer.innerHTML = `
//         <div class="swatch-drawer-header">

//           <div class="swatch-drawer-product-image-wrap">
//             <img
//               class="swatch-drawer-product-image"
//               src=""
//               alt=""
//             >
//           </div>

//           <h3>
//             Choose Material
//             <span id="choosed-color"></span>
//           </h3>

//           <button
//             type="button"
//             class="swatch-drawer-close"
//             aria-label="Close drawer"
//           >
//             ×
//           </button>

//         </div>

//         <div class="swatch-drawer-grid"></div>

//         <button
//           type="button"
//           class="swatch-drawer-confirm"
//         >
//           Confirm selection
//         </button>

//         <a
//           target="_blank"
//           href="${fabricLink}"
//           class="swatch-drawer-confirm swatch-drawer-btn swatch-drawer-btn-secondary"
//         >
//           Can't find the right fabric? View more here.
//         </a>

//         <a
//           target="_blank"
//           href="/pages/fabric-composition"
//           class="swatch-drawer-confirm swatch-drawer-btn swatch-drawer-btn-secondary"
//         >
//           More about sofa fabric compositions
//         </a>
//       `;

//               document.body.appendChild(drawer);
//             }

//             const grid = drawer.querySelector('.swatch-drawer-grid');

//             /*
//              * CREATE INFO POPUP
//              */

//             let infoPopup = document.querySelector('.swatch-info-popup');

//             if (!infoPopup) {
//               infoPopup = document.createElement('div');
//               infoPopup.className = 'swatch-info-popup';

//               infoPopup.innerHTML = `
//         <div class="swatch-info-popup-inner">

//           <button
//             type="button"
//             class="swatch-info-close"
//             aria-label="Close popup"
//           >
//             &times;
//           </button>

//           <div class="swatch-info-image-wrap">
//             <img
//               class="swatch-info-image"
//               src=""
//               alt=""
//             >

//             <div class="swatch-info-image-error">
//               Image unavailable
//             </div>
//           </div>

//           <div class="swatch-info-content">

//             <h2 class="swatch-info-title"></h2>

//             <div class="swatch-info-description"></div>

//           </div>

//         </div>
//       `;

//               document.body.appendChild(infoPopup);
//             }

//             const infoImage = infoPopup.querySelector('.swatch-info-image');

//             const infoTitle = infoPopup.querySelector('.swatch-info-title');

//             const infoDescription = infoPopup.querySelector('.swatch-info-description');

//             const imageError = infoPopup.querySelector('.swatch-info-image-error');

//             /*
//              * FABRIC DETAILS
//              *
//              * Update these descriptions as required.
//              */

//             const swatchDetails = {
//               'Black Leather R-02': {
//                 description: 'Premium black leather upholstery.',
//               },

//               'Chocolate Leather R-04': {
//                 description: 'Rich chocolate-toned leather upholstery.',
//               },

//               'Light Tan Leather R-05': {
//                 description: 'Light tan leather upholstery.',
//               },

//               'Grey Leather R-12': {
//                 description: 'Grey leather upholstery.',
//               },

//               'Light Grey Leather RS-20': {
//                 description: 'Light grey leather upholstery.',
//               },

//               'Camel Leather RS-30': {
//                 description: 'Camel-toned leather upholstery.',
//               },

//               'Army Grey Leather RS-32': {
//                 description: 'Army grey leather upholstery.',
//               },

//               'Anchor Leather RS-35': {
//                 description: 'Anchor-toned leather upholstery.',
//               },

//               'Sienna Brown Leather RS-36': {
//                 description: 'Sienna brown leather upholstery.',
//               },

//               'Tan Leather Q-13': {
//                 description: 'Tan leather upholstery.',
//               },
//             };

//             /*
//              * GET IMAGE URL
//              *
//              * Extracts the URL from the background-image style.
//              */

//             function getSwatchImage(item) {
//               const imageElement = item.querySelector('.star-set-image');

//               if (!imageElement) return '';

//               // Read the original inline style first
//               const style = imageElement.getAttribute('style') || '';

//               let match = style.match(/background-image\s*:\s*url\(\s*(['"]?)(.*?)\1\s*\)/i);

//               // Fallback to computed CSS
//               if (!match) {
//                 const computedStyle = window.getComputedStyle(imageElement);

//                 match = computedStyle.backgroundImage.match(/url\(\s*(['"]?)(.*?)\1\s*\)/i);
//               }

//               if (!match || !match[2]) {
//                 console.warn('Swatch image URL not found:', item);
//                 return '';
//               }

//               return match[2].trim();
//             }

//             /*
//              * GENERATE POSSIBLE IMAGE URLS
//              *
//              * Some CDN URLs contain %2520.
//              * We try the original and decoded versions.
//              */

//             function getImageCandidates(rawUrl) {
//               const urls = [];

//               function addUrl(url) {
//                 if (url && !urls.includes(url)) {
//                   urls.push(url);
//                 }
//               }

//               addUrl(rawUrl);

//               // Decode once: %2520 -> %20
//               try {
//                 addUrl(decodeURIComponent(rawUrl));
//               } catch (error) {}

//               // Decode twice if required
//               try {
//                 addUrl(decodeURIComponent(decodeURIComponent(rawUrl)));
//               } catch (error) {}

//               // Encode spaces correctly
//               try {
//                 addUrl(encodeURI(decodeURIComponent(rawUrl)));
//               } catch (error) {}

//               return urls;
//             }

//             /*
//              * LOAD IMAGE USING MULTIPLE URL FORMATS
//              */

//             function loadSwatchImage(urls, index, swatchName) {
//               if (index >= urls.length) {
//                 console.error('Unable to load swatch image. URLs tested:', urls);

//                 infoImage.style.display = 'none';
//                 imageError.style.display = 'block';

//                 return;
//               }

//               const imageUrl = urls[index];

//               const testImage = new Image();

//               testImage.onload = function () {
//                 infoImage.src = imageUrl;
//                 infoImage.alt = swatchName;
//                 infoImage.style.display = 'block';

//                 imageError.style.display = 'none';
//               };

//               testImage.onerror = function () {
//                 loadSwatchImage(urls, index + 1, swatchName);
//               };

//               testImage.src = imageUrl;
//             }

//             /*
//              * OPEN INFO POPUP
//              */

//             function openInfoPopup(item) {
//               const swatchName = item.getAttribute('orig-value') || item.getAttribute('aria-label') || 'Swatch details';

//               const rawImageUrl = getSwatchImage(item);

//               infoTitle.textContent = swatchName;

//               if (swatchDetails[swatchName]) {
//                 infoDescription.textContent = swatchDetails[swatchName].description;
//               } else {
//                 infoDescription.textContent = 'More information about this fabric will be available soon.';
//               }

//               infoImage.removeAttribute('src');
//               infoImage.style.display = 'none';
//               imageError.style.display = 'none';

//               infoPopup.classList.add('active');

//               if (rawImageUrl) {
//                 const imageUrls = getImageCandidates(rawImageUrl);

//                 loadSwatchImage(imageUrls, 0, swatchName);
//               } else {
//                 imageError.style.display = 'block';
//               }
//             }

//             /*
//              * CLOSE INFO POPUP
//              */

//             function closeInfoPopup() {
//               infoPopup.classList.remove('active');
//             }

//             /*
//              * SET PRODUCT IMAGE
//              */

//             function setDrawerProductImage() {
//               const firstCarouselImg = document.querySelector(
//                 '.custom-carousel__slides .custom-carousel__slide:first-child img'
//               );

//               const selectedSwatch = document.querySelector('div[option-name="Upholstery"] .swatch-variant-name');

//               const chosenColor = drawer.querySelector('#choosed-color');

//               if (selectedSwatch && chosenColor) {
//                 chosenColor.textContent = selectedSwatch.innerText;
//               }

//               const drawerImg = drawer.querySelector('.swatch-drawer-product-image');

//               const drawerImgWrap = drawer.querySelector('.swatch-drawer-product-image-wrap');

//               if (firstCarouselImg && drawerImg) {
//                 drawerImg.src = firstCarouselImg.currentSrc || firstCarouselImg.src;

//                 drawerImg.alt = firstCarouselImg.alt || 'Product image';

//                 drawerImgWrap.style.display = 'block';
//               } else {
//                 drawerImgWrap.style.display = 'none';
//               }
//             }

//             /*
//              * OPEN DRAWER
//              */

//             function openDrawer() {
//               grid.innerHTML = '';

//               setDrawerProductImage();

//               const latestItems = swatchList.querySelectorAll(':scope > .swatch-view-item');

//               latestItems.forEach(function (item) {
//                 const clone = item.cloneNode(true);

//                 clone.style.display = 'block';

//                 /*
//                  * CREATE MORE INFO BUTTON
//                  */

//                 const infoLink = document.createElement('button');

//                 infoLink.type = 'button';
//                 infoLink.className = 'swatch-more-info-link';
//                 infoLink.textContent = 'More info';

//                 infoLink.addEventListener('click', function (event) {
//                   event.preventDefault();
//                   event.stopPropagation();

//                   // Use the original swatch item
//                   openInfoPopup(item);
//                 });

//                 /*
//                  * INSERT BUTTON BELOW IMAGE
//                  */

//                 const imageWrapper = clone.querySelector('.swatch-image-wrapper');

//                 if (imageWrapper) {
//                   imageWrapper.insertAdjacentElement('afterend', infoLink);
//                 } else {
//                   clone.appendChild(infoLink);
//                 }

//                 /*
//                  * SWATCH SELECTION
//                  */

//                 clone.addEventListener('click', function (event) {
//                   if (event.target.closest('.swatch-more-info-link')) {
//                     return;
//                   }

//                   const value = clone.getAttribute('orig-value');

//                   const original = swatchList.querySelector(
//                     '.swatch-view-item[orig-value="' + CSS.escape(value) + '"] .swatch-selector'
//                   );

//                   if (original) {
//                     original.click();
//                   }

//                   grid.querySelectorAll('.swatch-view-item').forEach(function (el) {
//                     el.classList.remove('active');
//                   });

//                   clone.classList.add('active');
//                 });

//                 grid.appendChild(clone);
//               });

//               drawer.classList.add('active');
//               overlay.classList.add('active');

//               document.body.style.overflow = 'hidden';
//             }

//             /*
//              * CLOSE DRAWER
//              */

//             function closeDrawer() {
//               drawer.classList.remove('active');
//               overlay.classList.remove('active');

//               closeInfoPopup();

//               document.body.style.overflow = '';
//             }

//             /*
//              * EVENT LISTENERS
//              */

//             if (!moreBtn.dataset.listenerAdded) {
//               moreBtn.addEventListener('click', openDrawer);

//               moreBtn.dataset.listenerAdded = 'true';
//             }

//             if (!overlay.dataset.listenerAdded) {
//               overlay.addEventListener('click', closeDrawer);

//               overlay.dataset.listenerAdded = 'true';
//             }

//             if (!drawer.dataset.listenerAdded) {
//               drawer.querySelector('.swatch-drawer-close').addEventListener('click', closeDrawer);

//               drawer.querySelector('.swatch-drawer-confirm').addEventListener('click', closeDrawer);

//               drawer.dataset.listenerAdded = 'true';
//             }

//             if (!infoPopup.dataset.listenerAdded) {
//               infoPopup.querySelector('.swatch-info-close').addEventListener('click', closeInfoPopup);

//               infoPopup.addEventListener('click', function (event) {
//                 if (event.target === infoPopup) {
//                   closeInfoPopup();
//                 }
//               });

//               infoPopup.dataset.listenerAdded = 'true';
//             }

//             /*
//              * ESCAPE KEY
//              */

//             if (!document.body.dataset.swatchEscapeReady) {
//               document.addEventListener('keydown', function (event) {
//                 if (event.key === 'Escape') {
//                   closeInfoPopup();
//                 }
//               });

//               document.body.dataset.swatchEscapeReady = 'true';
//             }

//             initialized = true;
//           }

//           /*
//            * INITIALIZE
//            */

//           initSwatchDrawer();

//           /*
//            * HANDLE DYNAMICALLY LOADED SWATCHES
//            */

//           const observer = new MutationObserver(function () {
//             initSwatchDrawer();
//           });

//           observer.observe(document.body, {
//             childList: true,
//             subtree: true,
//           });
//         });




document.addEventListener('DOMContentLoaded', function () {

  function initSwatchDrawer() {

    const swatchContainer = document.querySelector(
      '[option-name="Upholstery"]'
    );

    if (!swatchContainer) return;

    const swatchList = swatchContainer.querySelector(
      '.swatch-view-custom-image'
    );

    if (!swatchList) return;

    const items = swatchList.querySelectorAll(
      ':scope > .swatch-view-item'
    );

    if (items.length <= 4) return;

    /*
     * CREATE MORE BUTTON
     */

    let moreBtn = swatchList.parentElement.querySelector(
      '.swatch-more-btn'
    );

    if (!moreBtn) {
      moreBtn = document.createElement('button');
      moreBtn.type = 'button';
      moreBtn.className = 'swatch-more-btn';
      moreBtn.innerHTML = '+ more &gt;';
      swatchList.after(moreBtn);
    }

    /*
     * CREATE SHARED OVERLAY
     */

    let overlay = document.querySelector(
      '.swatch-drawer-overlay'
    );

    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'swatch-drawer-overlay';
      document.body.appendChild(overlay);
    }

    /*
     * CREATE MAIN SWATCH DRAWER
     */

    let drawer = document.querySelector('.swatch-drawer');

    if (!drawer) {

      const vendorElement = document.querySelector(
        '.vendor.product-detail__gap-sm'
      );

      const vendor = vendorElement
        ? vendorElement.innerText.trim()
        : '';

      const vendorText = vendor.toLowerCase();

      let fabricLink = '/pages/bauhaus-studio-upholstery';

      if (vendorText.includes('mcm house')) {
        fabricLink = '/pages/mcm-house-swatches';
      } else if (vendorText.includes('bauhaus studio')) {
        fabricLink = '/pages/bauhaus-studio-upholstery';
      } else if (vendorText.includes('camerich')) {
        fabricLink = '/pages/camerich-upholstery';
      }

      drawer = document.createElement('div');
      drawer.className = 'swatch-drawer';

      drawer.innerHTML = `

        <div class="swatch-drawer-header">

          <div class="swatch-drawer-product-image-wrap">

            <img
              class="swatch-drawer-product-image"
              src=""
              alt=""
            >

          </div>

          <h3>
            Choose Material
            <span id="choosed-color"></span>
          </h3>

          <button
            type="button"
            class="swatch-drawer-close"
            aria-label="Close drawer"
          >
            ×
          </button>

        </div>

        <div class="swatch-drawer-grid"></div>

        <button
          type="button"
          class="swatch-drawer-confirm"
        >
          Confirm selection
        </button>

        <a
          target="_blank"
          href="${fabricLink}"
          class="swatch-drawer-confirm swatch-drawer-btn swatch-drawer-btn-secondary"
        >
          Can't find the right fabric? View more here.
        </a>

        <a
          target="_blank"
          href="/pages/fabric-composition"
          class="swatch-drawer-confirm swatch-drawer-btn swatch-drawer-btn-secondary"
        >
          More about sofa fabric compositions
        </a>

      `;

      document.body.appendChild(drawer);
    }

    const grid = drawer.querySelector(
      '.swatch-drawer-grid'
    );

    /*
     * CREATE FABRIC INFO DRAWER
     */

    let infoDrawer = document.querySelector(
      '.swatch-info-drawer'
    );

    if (!infoDrawer) {

      infoDrawer = document.createElement('div');

      infoDrawer.className = 'swatch-info-drawer';

      infoDrawer.innerHTML = `

        <div class="swatch-info-drawer-header">

          <h2 class="swatch-info-title"></h2>

          <button
            type="button"
            class="swatch-info-close"
            aria-label="Close fabric details"
          >
            ×
          </button>

        </div>

        <div class="swatch-info-drawer-body">

          <div class="swatch-info-image-wrap">

            <img
              class="swatch-info-image"
              src=""
              alt=""
            >

            <div class="swatch-info-image-error">
              Image unavailable
            </div>

          </div>

          <div class="swatch-info-content">

            <div class="swatch-info-description"></div>

          </div>

        </div>

      `;

      document.body.appendChild(infoDrawer);
    }

    const infoImage = infoDrawer.querySelector(
      '.swatch-info-image'
    );

    const infoTitle = infoDrawer.querySelector(
      '.swatch-info-title'
    );

    const infoDescription = infoDrawer.querySelector(
      '.swatch-info-description'
    );

    const imageError = infoDrawer.querySelector(
      '.swatch-info-image-error'
    );

    /*
     * FABRIC DETAILS
     */

    const swatchDetails = {

      'Black Leather R-02': {
        description: 'Premium black leather upholstery.'
      },

      'Chocolate Leather R-04': {
        description: 'Rich chocolate-toned leather upholstery.'
      },

      'Light Tan Leather R-05': {
        description: 'Light tan leather upholstery.'
      },

      'Grey Leather R-12': {
        description: 'Grey leather upholstery.'
      },

      'Light Grey Leather RS-20': {
        description: 'Light grey leather upholstery.'
      },

      'Camel Leather RS-30': {
        description: 'Camel-toned leather upholstery.'
      },

      'Army Grey Leather RS-32': {
        description: 'Army grey leather upholstery.'
      },

      'Anchor Leather RS-35': {
        description: 'Anchor-toned leather upholstery.'
      },

      'Sienna Brown Leather RS-36': {
        description: 'Sienna brown leather upholstery.'
      },

      'Tan Leather Q-13': {
        description: 'Tan leather upholstery.'
      }

    };

    /*
     * GET SWATCH IMAGE URL
     */

    function getSwatchImage(item) {

      const imageElement = item.querySelector(
        '.star-set-image'
      );

      if (!imageElement) return '';

      const style =
        imageElement.getAttribute('style') || '';

      let match = style.match(
        /background-image\s*:\s*url\(\s*(['"]?)(.*?)\1\s*\)/i
      );

      if (!match) {

        const computedStyle = window.getComputedStyle(
          imageElement
        );

        match = computedStyle.backgroundImage.match(
          /url\(\s*(['"]?)(.*?)\1\s*\)/i
        );

      }

      if (!match || !match[2]) {

        console.warn(
          'Swatch image URL not found:',
          item
        );

        return '';

      }

      return match[2].trim();

    }

    /*
     * GENERATE IMAGE URL CANDIDATES
     */

    function getImageCandidates(rawUrl) {

      const urls = [];

      function addUrl(url) {

        if (url && !urls.includes(url)) {
          urls.push(url);
        }

      }

      addUrl(rawUrl);

      try {
        addUrl(decodeURIComponent(rawUrl));
      } catch (error) {}

      try {
        addUrl(
          decodeURIComponent(
            decodeURIComponent(rawUrl)
          )
        );
      } catch (error) {}

      try {
        addUrl(
          encodeURI(
            decodeURIComponent(rawUrl)
          )
        );
      } catch (error) {}

      return urls;

    }

    /*
     * LOAD SWATCH IMAGE
     */

    function loadSwatchImage(
      urls,
      index,
      swatchName
    ) {

      if (index >= urls.length) {

        console.error(
          'Unable to load swatch image. URLs tested:',
          urls
        );

        infoImage.style.display = 'none';
        imageError.style.display = 'block';

        return;

      }

      const imageUrl = urls[index];

      const testImage = new Image();

      testImage.onload = function () {

        infoImage.src = imageUrl;
        infoImage.alt = swatchName;
        infoImage.style.display = 'block';

        imageError.style.display = 'none';

      };

      testImage.onerror = function () {

        loadSwatchImage(
          urls,
          index + 1,
          swatchName
        );

      };

      testImage.src = imageUrl;

    }

    /*
     * CLOSE ALL DRAWERS
     */

    function closeAllDrawers() {

      drawer.classList.remove('active');

      infoDrawer.classList.remove('active');

      overlay.classList.remove('active');

      document.body.style.overflow = '';

    }

    /*
     * OPEN FABRIC INFO DRAWER
     *
     * IMPORTANT:
     * The main drawer remains open.
     */

    function openInfoDrawer(item) {

      const swatchName =
        item.getAttribute('orig-value') ||
        item.getAttribute('aria-label') ||
        'Swatch details';

      const rawImageUrl = getSwatchImage(item);

      infoTitle.textContent = swatchName;

      if (swatchDetails[swatchName]) {

        infoDescription.textContent =
          swatchDetails[swatchName].description;

      } else {

        infoDescription.textContent =
          'More information about this fabric will be available soon.';

      }

      infoImage.removeAttribute('src');

      infoImage.style.display = 'none';

      imageError.style.display = 'none';

      /*
       * DO NOT CLOSE THE MAIN DRAWER
       */

      drawer.classList.add('active');

      /*
       * OPEN INFO DRAWER ABOVE MAIN DRAWER
       */

      infoDrawer.classList.add('active');

      overlay.classList.add('active');

      document.body.style.overflow = 'hidden';

      if (rawImageUrl) {

        const imageUrls = getImageCandidates(
          rawImageUrl
        );

        loadSwatchImage(
          imageUrls,
          0,
          swatchName
        );

      } else {

        imageError.style.display = 'block';

      }

    }

    /*
     * CLOSE ONLY THE INFO DRAWER
     */

    function closeInfoDrawer() {

      /*
       * Close only the info drawer.
       * Keep the main drawer open.
       */

      infoDrawer.classList.remove('active');

      drawer.classList.add('active');

      overlay.classList.add('active');

      document.body.style.overflow = 'hidden';

    }

    /*
     * SET PRODUCT IMAGE
     */

    function setDrawerProductImage() {

      const firstCarouselImg = document.querySelector(
        '.custom-carousel__slides .custom-carousel__slide:first-child img'
      );

      const selectedSwatch = document.querySelector(
        'div[option-name="Upholstery"] .swatch-variant-name'
      );

      const chosenColor = drawer.querySelector(
        '#choosed-color'
      );

      if (selectedSwatch && chosenColor) {

        chosenColor.textContent =
          selectedSwatch.innerText;

      }

      const drawerImg = drawer.querySelector(
        '.swatch-drawer-product-image'
      );

      const drawerImgWrap = drawer.querySelector(
        '.swatch-drawer-product-image-wrap'
      );

      if (firstCarouselImg && drawerImg) {

        drawerImg.src =
          firstCarouselImg.currentSrc ||
          firstCarouselImg.src;

        drawerImg.alt =
          firstCarouselImg.alt ||
          'Product image';

        drawerImgWrap.style.display = 'block';

      } else {

        drawerImgWrap.style.display = 'none';

      }

    }

    /*
     * OPEN MAIN SWATCH DRAWER
     */

    function openDrawer() {

      infoDrawer.classList.remove('active');

      grid.innerHTML = '';

      setDrawerProductImage();

      const latestItems = swatchList.querySelectorAll(
        ':scope > .swatch-view-item'
      );

      latestItems.forEach(function (item) {

        const clone = item.cloneNode(true);

        clone.style.display = 'block';

        /*
         * CREATE MORE INFO BUTTON
         */

        const infoLink = document.createElement('button');

        infoLink.type = 'button';

        infoLink.className = 'swatch-more-info-link';

        infoLink.textContent = 'More info';

        infoLink.addEventListener('click', function (event) {

          event.preventDefault();

          event.stopPropagation();

          openInfoDrawer(item);

        });

        /*
         * INSERT MORE INFO LINK
         */

        const imageWrapper = clone.querySelector(
          '.swatch-image-wrapper'
        );

        if (imageWrapper) {

          imageWrapper.insertAdjacentElement(
            'afterend',
            infoLink
          );

        } else {

          clone.appendChild(infoLink);

        }

        /*
         * SWATCH SELECTION
         */

        clone.addEventListener('click', function (event) {

          if (
            event.target.closest(
              '.swatch-more-info-link'
            )
          ) {
            return;
          }

          const value = clone.getAttribute(
            'orig-value'
          );

          const original = swatchList.querySelector(
            '.swatch-view-item[orig-value="' +
              CSS.escape(value) +
              '"] .swatch-selector'
          );

          if (original) {
            original.click();
          }

          grid
            .querySelectorAll('.swatch-view-item')
            .forEach(function (el) {

              el.classList.remove('active');

            });

          clone.classList.add('active');

        });

        grid.appendChild(clone);

      });

      drawer.classList.add('active');

      overlay.classList.add('active');

      document.body.style.overflow = 'hidden';

    }

    /*
     * CLOSE MAIN DRAWER
     */

    function closeDrawer() {

      /*
       * Close both drawers.
       */

      drawer.classList.remove('active');

      infoDrawer.classList.remove('active');

      overlay.classList.remove('active');

      document.body.style.overflow = '';

    }

    /*
     * EVENT LISTENERS
     */

    if (!moreBtn.dataset.listenerAdded) {

      moreBtn.addEventListener(
        'click',
        openDrawer
      );

      moreBtn.dataset.listenerAdded = 'true';

    }

    if (!overlay.dataset.listenerAdded) {

      overlay.addEventListener(
        'click',
        closeAllDrawers
      );

      overlay.dataset.listenerAdded = 'true';

    }

    if (!drawer.dataset.listenerAdded) {

      const closeButton = drawer.querySelector(
        '.swatch-drawer-close'
      );

      const confirmButton = drawer.querySelector(
        '.swatch-drawer-confirm'
      );

      if (closeButton) {

        closeButton.addEventListener(
          'click',
          closeDrawer
        );

      }

      if (confirmButton) {

        confirmButton.addEventListener(
          'click',
          closeDrawer
        );

      }

      drawer.dataset.listenerAdded = 'true';

    }

    if (!infoDrawer.dataset.listenerAdded) {

      const infoCloseButton = infoDrawer.querySelector(
        '.swatch-info-close'
      );

      if (infoCloseButton) {

        infoCloseButton.addEventListener(
          'click',
          closeInfoDrawer
        );

      }

      infoDrawer.dataset.listenerAdded = 'true';

    }

    /*
     * ESCAPE KEY
     */

    if (!document.body.dataset.swatchEscapeReady) {

      document.addEventListener('keydown', function (event) {

        if (event.key === 'Escape') {

          if (infoDrawer.classList.contains('active')) {

            closeInfoDrawer();

          } else if (drawer.classList.contains('active')) {

            closeDrawer();

          }

        }

      });

      document.body.dataset.swatchEscapeReady = 'true';

    }

  }

  /*
   * INITIALIZE
   */

  initSwatchDrawer();

  /*
   * HANDLE DYNAMICALLY LOADED SWATCHES
   */

  const observer = new MutationObserver(function () {

    initSwatchDrawer();

  });

  observer.observe(document.body, {

    childList: true,
    subtree: true

  });

});